import { render, staticRenderFns } from "./EditEventPage.vue?vue&type=template&id=1ad26d21&"
import script from "./EditEventPage.vue?vue&type=script&lang=js&"
export * from "./EditEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports